import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/bluesky-vue-logo.png';
import blueSkyLogoOnly from '../../assets/images/bluesky-vue-logo-only.png';
import classnames from 'classnames';
import { AppContext } from '../../AppContext';

// Components
import Navigation from '../Navigation';
import FullScreenLoading from '../FullScreenLoading';

// Icons
import ChevronRight from '@material-ui/icons/ChevronRight';
import ListIcon from '@material-ui/icons/List';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

// Extra
import Avatar from '@material-ui/core/Avatar';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

// Services
import { logout as authLogout } from '../../services';
import { isSmallDevice } from '../../helpers';

export const PageTemplate = props => {
  const { isVerifying, children, navTree } = props;

  const {
    state: { accountDropdownIsOpen, sidebarIsOpen, pageTitle, accountName, userId },
    dispatch,
  } = useContext(AppContext);

  const attemptLogout = async () => {
    authLogout();
    dispatch({
      type: 'UPDATE_ROLES',
      roles: [],
    });
    closeAccountDropdown();
  };

  const toggleAccountDropdown = () => {
    dispatch({
      type: 'SET_ACCOUNT_DROPDOWN_IS_OPEN',
      accountDropdownIsOpen: !accountDropdownIsOpen,
    });
    // setAccountDropdownOpen(!accountDropdownOpen);
  };

  const closeAccountDropdown = () => {
    dispatch({
      type: 'SET_ACCOUNT_DROPDOWN_IS_OPEN',
      accountDropdownIsOpen: false,
    });
    // setAccountDropdownOpen(false);
  };

  const toggleSidebar = open => {
    dispatch({
      type: 'SET_SIDEBAR_IS_OPEN',
      sidebarIsOpen: open,
    });
    // setSidebarOpen(!sidebarOpen);
  };

  return !isVerifying ? (
    <div className="app">
      {/* App Sidebar */}
      <div className={classnames('app-sidebar', !sidebarIsOpen && 'app-sidebar-closed')}>
        <div className="sidebar-logo-container">
          {isSmallDevice() && (
            <ChevronLeftIcon
              className={classnames('sidebar-toggle-icon')}
              style={{ marginLeft: 0, marginRight: 15 }}
              onClick={() => toggleSidebar(!sidebarIsOpen)}
            />
          )}

          <img src={logo} className="sidebar-logo" alt="JMI Bluesky VUE logo" />
        </div>

        <Navigation links={navTree.filter(r => !r.hideNavLink)} />
      </div>

      {/* App Main (everything except for the sidebar) */}
      <div
        className="app-main"
        onClick={() => {
          if (isSmallDevice() && sidebarIsOpen) {
            toggleSidebar(false);
          }
        }}
      >
        <div className="app-header">
          <ListIcon
            className={classnames('sidebar-toggle-icon', 'mr-20', !sidebarIsOpen && 'sidebar-toggle-icon-closed')}
            onClick={() => toggleSidebar(!sidebarIsOpen)}
          />

          <div className="app-header-left">
            <div className="app-header-title" title={pageTitle}>
              {pageTitle}
            </div>
          </div>

          <div className="row-center-center">
            {!isSmallDevice() && (
              <Avatar
                alt="Profile pic"
                style={{
                  border: '1px solid #ccc',
                  padding: 2,
                  marginLeft: 25,
                  marginRight: 20,
                }}
                src={blueSkyLogoOnly}
              />
            )}

            <div style={{ position: 'relative' }}>
              <ClickAwayListener onClickAway={closeAccountDropdown}>
                <div>
                  {isSmallDevice() ? (
                    <Avatar
                      onClick={toggleAccountDropdown}
                      alt="Profile pic"
                      style={{
                        border: '1px solid #ccc',
                        padding: 2,
                        marginLeft: 25,
                        marginRight: 20,
                      }}
                      src={blueSkyLogoOnly}
                    />
                  ) : (
                    <div onClick={toggleAccountDropdown} className={classnames('account-button')}>
                      {accountName}{' '}
                      <ChevronRight className={classnames('rotate-90')} style={{ color: '#aaa', marginLeft: 5 }} />
                    </div>
                  )}
                  {accountDropdownIsOpen ? (
                    // zIndex of 1100 is the Material UI Tab bar zIndex.  So go to 1101 to overlap it
                    <Paper
                      className="account-dropdown-paper"
                      style={{
                        zIndex: 1101,
                        minWidth: 100,
                      }}
                    >
                      <div className={classnames('account-dropdown-paper-section')}>
                        <Link onClick={closeAccountDropdown} className="account-dropdown-link" to={`/my-account`}>
                          My Account
                        </Link>
                      </div>
                      <div className={classnames('account-dropdown-paper-section')}>
                        <Link onClick={attemptLogout} className="account-dropdown-link" to={'/login'}>
                          Logout
                        </Link>
                      </div>
                    </Paper>
                  ) : null}
                </div>
              </ClickAwayListener>
            </div>
          </div>
        </div>

        {/* App Body (where the router shows all content) */}
        <div className="app-body">
          <div className="app-body-with-padding">{children}</div>
        </div>
      </div>
    </div>
  ) : (
    <FullScreenLoading />
  );
};
